import React from "react";

import { Box, Typography } from "@mui/material";

import { black, grayDark } from "globals/design-system/colors";

type SuggestedStartTimeBlockProps = {
  startTime: string;
  label?: string;
  compact?: boolean;
};

const SuggestedStartTimeBlock = (props: SuggestedStartTimeBlockProps) => {
  const { startTime, label = "Start Time", compact = false } = props;
  return (
    <Box display="flex" flexDirection="column">
      <Typography variant="overline" style={{ color: grayDark }}>
        {label}
      </Typography>
      <Typography
        variant={compact ? "caption" : "body1"}
        style={compact ? { color: black } : { fontWeight: "bold" }}
      >
        {startTime}
      </Typography>
      {!compact && (
        <Typography variant="caption" style={{ color: grayDark }}>
          Time to start the trip in order to arrive to the pick up location on
          time
        </Typography>
      )}
    </Box>
  );
};

export default SuggestedStartTimeBlock;
